// Add styles directly to ensure they're applied
const style = document.createElement('style')
style.textContent = `
  .hardship-details-hidden {
    display: none !important;
  }
`
document.head.appendChild(style)

document.addEventListener('DOMContentLoaded', function () {
  console.log('Hardship form script loaded')

  // First, hide all detail inputs and remove required attribute
  const allDetailInputs = document.querySelectorAll('textarea[placeholder="Tell us more..."]')
  console.log('Found detail inputs:', allDetailInputs.length)

  allDetailInputs.forEach(input => {
    input.classList.add('hardship-details-hidden')
    // Store the original required state if it exists
    if (input.hasAttribute('required')) {
      input.dataset.wasRequired = true
      input.removeAttribute('required')
    }
    console.log('Added hidden class to input:', input)
  })

  // Add event listeners to all checkboxes
  const checkboxes = document.querySelectorAll('input[type="checkbox"]')
  console.log('Found checkboxes:', checkboxes.length)

  checkboxes.forEach(checkbox => {
    // Get the associated details input (it's in the next form-group div)
    const detailsInput = checkbox
      .closest('.form-group')
      .nextElementSibling?.querySelector('textarea[placeholder="Tell us more..."]')
    console.log('Found associated input for checkbox:', checkbox.id, detailsInput)

    if (detailsInput) {
      // Set initial state if checked
      if (checkbox.checked) {
        detailsInput.classList.remove('hardship-details-hidden')
        // Restore required attribute if it was originally required
        if (detailsInput.dataset.wasRequired) {
          detailsInput.setAttribute('required', 'required')
        }
        console.log('Showing input for checked checkbox:', checkbox.id)
      }

      // Add change event listener
      checkbox.addEventListener('change', function () {
        console.log('Checkbox changed:', this.id, this.checked)
        if (this.checked) {
          detailsInput.classList.remove('hardship-details-hidden')
          // Restore required attribute if it was originally required
          if (detailsInput.dataset.wasRequired) {
            detailsInput.setAttribute('required', 'required')
          }
        } else {
          detailsInput.classList.add('hardship-details-hidden')
          // Remove required attribute to avoid validation errors on hidden fields
          if (detailsInput.hasAttribute('required')) {
            detailsInput.removeAttribute('required')
          }
        }
      })
    }
  })
})
